query GetCompany($id: ID!) {
  company(id: $id) {
    id
    name
    salesforceId
    companyType {
      id
      name
      description
    }
  }
}
